/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateWorkflowModelSchemaRequest
 */
export interface ValidateWorkflowModelSchemaRequest {
    /**
     * 
     * @type {object}
     * @memberof ValidateWorkflowModelSchemaRequest
     */
    definition?: object;
    /**
     * 
     * @type {object}
     * @memberof ValidateWorkflowModelSchemaRequest
     */
    dataSchema?: object;
    /**
     * 
     * @type {object}
     * @memberof ValidateWorkflowModelSchemaRequest
     */
    policy?: object;
}

/**
 * Check if a given object implements the ValidateWorkflowModelSchemaRequest interface.
 */
export function instanceOfValidateWorkflowModelSchemaRequest(value: object): value is ValidateWorkflowModelSchemaRequest {
    return true;
}

export function ValidateWorkflowModelSchemaRequestFromJSON(json: any): ValidateWorkflowModelSchemaRequest {
    return ValidateWorkflowModelSchemaRequestFromJSONTyped(json, false);
}

export function ValidateWorkflowModelSchemaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateWorkflowModelSchemaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'definition': json['definition'] == null ? undefined : json['definition'],
        'dataSchema': json['dataSchema'] == null ? undefined : json['dataSchema'],
        'policy': json['policy'] == null ? undefined : json['policy'],
    };
}

export function ValidateWorkflowModelSchemaRequestToJSON(json: any): ValidateWorkflowModelSchemaRequest {
    return ValidateWorkflowModelSchemaRequestToJSONTyped(json, false);
}

export function ValidateWorkflowModelSchemaRequestToJSONTyped(value?: ValidateWorkflowModelSchemaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'definition': value['definition'],
        'dataSchema': value['dataSchema'],
        'policy': value['policy'],
    };
}

